module.exports = __webpack_public_path__ + "static/img/8ZMuWbQw.ccd7f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/8ZMuWbQw.jpg
// module id = a+tn
// module chunks = 7